import React, { useEffect, useState } from 'react'
import { Actuator } from '../../models/smart-home.model'
import ActuatorBase from '../base/ActuatorBase'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { Box, CircularProgress } from '@mui/material'
import { useActuatorUpdate } from '../../hooks/use-actuator-update'
import OnOffToggle from '../base/OnOffToggle'

interface Props {
  serialNo: number
  actuator: Actuator
}

/**
 * Basic switch actuator component, for actuators that only support 'on' and 'off' states.
 */
const SimpleSwitch: React.FC<Props> = ({ serialNo, actuator }) => {
  const [actuatorState, setActuatorState] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const onUpdateActuator = useActuatorUpdate({ setIsLoading })

  useEffect(() => {
    const state = actuator.state === 'on'
    setActuatorState(state)
  }, [actuator])

  return (
    <ActuatorBase actuator={actuator}>
      <OptionalTooltipWrapper hasTooltip={actuator.state === 'unknown'} titleKey={'smart-home.actuator.unknown.tooltip'}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isLoading && <CircularProgress size={18} sx={{ top: '50%', left: '50%' }} />}
          <OnOffToggle
            disabled={actuator.state === 'unknown' || isLoading}
            checked={actuatorState}
            onChange={(_, checked) => onUpdateActuator(serialNo, actuator, { command: checked ? 'on' : 'off' })}
          />
        </Box>
      </OptionalTooltipWrapper>
    </ActuatorBase>
  )
}

export default SimpleSwitch
